/*
 * @Author: liujunhong
 * @Date: 2023/7/5
 * @Desc: 支付
 */

import React from 'react';
import Nav from '@/components/Nav';
import './index.less';


const Index = () => {
  return <div className=" wrap">
    <Nav activeMenu="pay"/>
    <div className=" main_center we_pay_tips">
      为保护用户账号安全，网页充值暂停使用，请直接进入到游戏内充值
    </div>
  </div>;
};
export default Index;
